import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

// Search contacts from a location based on a query for Audience Builder
export const searchContactsFromLocation = async <
  T extends Record<string, unknown>,
>({
  data,
  domain,
  headers,
  query,
  locationId,
  signal,
}: FetchRequestArgs & { locationId: string }): Promise<
  ReturnType<typeof fetchRequest>
> => {
  return fetchRequest<T>({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/contacts/search`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal,
  });
};
